export default {"src":"/trader-new/_next/static/media/notification_icon.5d664757.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};